var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAxtriaIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 19,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M31.563 18.045h-2.029S16.566-2.008 0 14.407c0 .006 14.486-18.662 31.563 3.638"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.86 0 9.996 6.997a15 15 0 0 1 2.046-.43l.818-2.02.74 1.891c.63-.017 1.272.006 1.937.076zm3.774 9.186a14.4 14.4 0 0 0-2.091-.338l1.62 4.139 2.005 5.047h2.103zm-11.15 8.842h2.097l2.802-7.399h.005l.677-1.665c-.677.11-1.37.268-2.075.483zM21.175 18.028H22.6l2.478-4.36c-.25-.245-.603-.588-.927-.88zM27.368 7.17l-2.12 3.79c.301.244.654.53.972.803l2.58-4.593z"
})));
export default SvgAxtriaIcon;